module.exports = __webpack_public_path__ + "static/media/BTC.82491fef.png";